<table *ngIf="passengerList">
    <thead>
        <tr>
            <td>
                <div class="header-space"></div>
            </td>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>
                <div class="content positioning">
                    <div class="grid" *ngFor="let passengerArray of passengerList"
                        [ngStyle]="{ 'page-break-after': passengerArray.length < 22 ? 'avoid' : 'always' }">
                        <table>
                            <tr>
                                <th translate>Sq. No.</th>
                                <th translate>Surname & Name</th>
                                <th translate>Sex</th>
                                <th translate>Cat.</th>
                                <th translate>Date of Birth</th>
                                <th translate>H</th>
                                <th translate>Docs. N°</th>
                                <th translate>Citizen</th>
                                <th translate>Vehicle</th>
                                <th translate>Type</th>
                                <th translate>Plate</th>
                            </tr>
                            <tr *ngFor="let passenger of passengerArray">
                                <td>{{passenger.sequenceNumber}}</td>
                                <td>{{passenger.fullName}}</td>
                                <td>{{passenger.genderId}}</td>
                                <td>{{passenger.personCategoryName}}</td>
                                <td>{{passenger.birthDate | date: 'shortDate'}}</td>
                                <td><app-checkbox [disabled]="true" [(ngModel)]="passenger.health"></app-checkbox></td>
                                <td>{{passenger.documentNumber}}</td>
                                <td>{{passenger.nationalityName}}</td>
                                <td>{{passenger.vehicleModel}}</td>
                                <td>{{passenger.vehicleTypeId}}</td>
                                <td>{{passenger.vehiclePlate}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </td>
        </tr>
    </tbody>
    <tfoot>
        <tr>
            <td>
                <div class="footer-space"></div>
            </td>
        </tr>
    </tfoot>
</table>
<div class="header positioning">
    <div class="leftHeader">
        <table style="width: 100%;">
            <tr>
                <td><b>M/V</b></td>
                <td><b>{{pdfPaxData?.vesselName}}</b></td>
            </tr>
            <tr>
                <td>IMO</td>
                <td>{{pdfPaxData?.vesselImoNumber}}</td>
            </tr>
            <tr>
                <td>Flag</td>
                <td>{{pdfPaxData?.vesselCountryName}}</td>
            </tr>
            <tr>
                <td>Call sign</td>
                <td>{{pdfPaxData?.vesselCallSign}}</td>
            </tr>
            <tr>
                <td>Disembarkation</td>
                <td></td>
            </tr>
        </table>
    </div>
    <div class="middleHeader">
        PASSENGER AND VEHICLE LIST - {{pdfPaxData?.portOfCallName}} (MONTENEGRO)
    </div>
    <div class="rightHeader">
        {{pdfPaxData?.createdDate | date: 'shortDate'}}
    </div>
</div>
